import Assert from "tbAssert";

import CurrentTbVersion from "tbClient/config/CurrentTbVersion";

const mAppRootId = `(TrackerBase/${CurrentTbVersion.major}.${CurrentTbVersion.minor}.${CurrentTbVersion.patch}${CurrentTbVersion.label} Root)`;
const mLocationSvc = new WeakMap();
const mLogSvc = new WeakMap();
const mAppInsightsSvc = new WeakMap();
const mCurrentlyTrackingPageView = new WeakMap();

class AppInsightsEventHandlerService {
    constructor($location, $log, appInsights) {
        Assert.StrictAssert($location != null, "App Insights Event Handler Service: Missing or Invalid Location Service");
        Assert.StrictAssert($log != null, "App Insights Event Handler Service: Missing or Invalid Log Service");
        Assert.StrictAssert(appInsights != null, "App Insights Event Handler Service: Missing or Invalid Application Insights Service");

        mLocationSvc.set(this, $location);
        mLogSvc.set(this, $log);
        mAppInsightsSvc.set(this, appInsights);
        mCurrentlyTrackingPageView.set(this, false);

        $log.debug("Built an App Insights Hook Handler Service Instance");
    }

    get isCurrentlyTrackingPageView() {
        return mCurrentlyTrackingPageView.get(this);
    }

    set isCurrentlyTrackingPageView(updatedVal) {
        mCurrentlyTrackingPageView.set(this, updatedVal);
        let trackingPageViewFlag = updatedVal ? "YES" : "NO";
        mLogSvc.get(this).debug(`Updated Currently Tracking Page View Flag: ${trackingPageViewFlag}`);
    }

    onTransitionStart(transition) {
        const logSvc = mLogSvc.get(this);
        const appInsightsSvc = mAppInsightsSvc.get(this);
        const locationSvc = mLocationSvc.get(this);
        if (this.isCurrentlyTrackingPageView === true) {
            logSvc.warn("Skipping Redundant Start Page View Telemetry Call");
            return;
        }
        let pagePath;
        try {
            pagePath = `${mAppRootId}/${transition.from().name}`;
        }
        finally {
            logSvc.debug("In AppInsights Transition Start Hook)");
            appInsightsSvc.stopTrackPage(pagePath, locationSvc.url());
            this.isCurrentlyTrackingPageView = false;
        }
    }

    onTransitionComplete(transition) {
        const logSvc = mLogSvc.get(this);
        const appInsightsSvc = mAppInsightsSvc.get(this);

        let pagePath;
        try {
            pagePath = `${mAppRootId}/${transition.to().name}`;
        }
        finally {
            logSvc.debug("In AppInsights Transition Success Hook");
            appInsightsSvc.startTrackPage(pagePath);
            this.isCurrentlyTrackingPageView = true;
        }
    }

    onSinglePageView(transition) {
        const logSvc = mLogSvc.get(this);
        const appInsightsSvc = mAppInsightsSvc.get(this);
        const locationSvc = mLocationSvc.get(this);

        let pagePath;
        try {
            pagePath = `${mAppRootId}/${transition.to().name}`;
        }
        finally {
            logSvc.debug("In AppInsights Stand-Alone Page View Hook");
            appInsightsSvc.trackPageView(pagePath, locationSvc.url());
            this.isCurrentlyTrackingPageView = false;
        }
    }
}

AppInsightsEventHandlerService.ServiceName = "appInsightsEventHandlerSvc";

AppInsightsEventHandlerService.$inject = [
    "$location",
    "$log",
    "appInsights"
];

export default AppInsightsEventHandlerService;



//////////////////
// WEBPACK FOOTER
// ./src/services/AppInsights/AppInsightsEventHandlerService.js
// module id = xyIG
// module chunks = 1